export class ContractPhoto {
    id?: number
    uri: string
    created_at?: string
    type?: string
    constructor(id: number, uri: string, created_at?: string, type?: string) {
        this.id = id
        this.uri = uri
        this.created_at = created_at
        this.type = type
    }

    isWeightReceipt() {
        return this.type === 'weight_receipt'
    }

    isSortationTicket() {
        return this.type === 'sortation_ticket'
    }

    isFruitWhole() {
        return this.type === 'fruit_whole' || this.type === 'fruit_pile'
    }

    isFruitSingle() {
        return this.type === 'fruit_single' || this.type === 'fruit_bunch' || this.type === "seller_fruit_pile"
    }

    isFruit() {
        return this.isFruitSingle() || this.isFruitWhole()
    }
}

export function buildContractPhoto(p: any): ContractPhoto {
    return new ContractPhoto(p.id, p.uri, p.created_at, p.type)
}